<template>
    <b-container class="bv-example-row">
        <alert :message="message" />
        <b-row>
            <b-col md="12">
                <h3>List of users</h3>
            </b-col>
        </b-row>

        <b-tabs content-class="mt-3" justified>
            <b-tab title="Registered users" active>
                <div class="overflow-auto">

                    <b-form-group label="Filter by email" label-for="filter-input" label-cols-sm="2" label-size="sm">
                        <b-input-group size="sm">
                            <b-form-input id="filter-input" v-model="filter_by_email" type="search"
                                placeholder="Type to Search" v-on:keyup.enter="download_list_of_users"></b-form-input>

                        </b-input-group>
                    </b-form-group>

                    <b-form-group label="Filter by uuid" label-for="filter-input" label-cols-sm="2" label-size="sm">
                        <b-input-group size="sm">
                            <b-form-input id="filter-input" v-model="filter_by_uuid" type="search"
                                placeholder="Type to Search" v-on:keyup.enter="download_list_of_users"></b-form-input>

                        </b-input-group>
                    </b-form-group>

                    <b-form-group label="Filter by role" label-for="filter-input" label-cols-sm="2" label-size="sm">
                        <b-input-group size="sm">
                            <b-form-select placeholder="" id="input-visible" v-model="filter_by_role_id"
                                :options="options" />

                        </b-input-group>
                    </b-form-group>

                    <b-button @click="download_list_of_users" variant="primary" class="mb-3">Filter</b-button>

                    <b-table id="registered-table" :items="users" :per-page="perPage" :current-page="currentPage"
                        :fields="user_fields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" small striped>
                        <template v-slot:cell(email)="data">
                            <router-link :to="'/user/' + data.item.uuid">{{ data.value }}</router-link>
                        </template>
                        <template v-slot:cell(is_active)="data">
                            <label v-if="data.value">&#9989;</label>
                            <label v-else>&#10060;</label>
                        </template>
                        <template v-slot:cell(created_at)="data">
                            <span>{{ new Date(data.value).toLocaleString() }}</span>
                        </template>
                        <template v-slot:cell(latest_entry_date)="data">
                            <span v-if="data.value">{{ new Date(data.value).toLocaleString() }}</span>
                        </template>
                    </b-table>

                    <b-pagination v-model="currentPage" :total-rows="this.totalRows" :per-page="perPage" align="fill"
                        size="sm"></b-pagination>
                </div>
            </b-tab>
            <b-tab title="Guest users">
                <b-table id="guest-table" ref="guestTable" :items="guest_users" :per-page="perPage" :current-page="1"
                    :fields="guest_fields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" small striped>
                    <template v-slot:cell(user)="data">
                        <router-link :to="'/user/' + data.value.uuid">{{ data.value.email }}</router-link>
                    </template>
                    <template v-slot:cell(latest_entry_date)="data">
                        <span v-if="data.value">{{ new Date(data.value).toLocaleString() }}</span>
                    </template>
                    <template v-slot:cell(space)="data">
                        <router-link :to="'/space/' + data.value.uuid">{{ data.value.name }}</router-link>
                    </template>
                    <template v-slot:cell(user_agent)="data">
                        <div :id="data.item.ip_address">{{ truncate(data.value, 30) }}</div>
                        <b-tooltip :target="data.item.ip_address" triggers="hover">
                            {{ data.value }}
                        </b-tooltip>
                    </template>
                </b-table>

                <b-pagination v-model="guestCurrentPage" :total-rows="this.guestTotalRows"
                    @input="download_list_of_guests" :per-page="perPage" align="fill" size="sm"></b-pagination>
            </b-tab>
        </b-tabs>

    </b-container>
</template>

<script>
import Alert from '../components/alert.vue';

export default {
    data() {
        return {
            sortBy: "latest_entry_date",
            sortDesc: true,
            message: '',
            perPage: 20,
            currentPage: 1,
            totalRows: null,
            users: [],
            guestCurrentPage: 1,
            guestTotalRows: null,
            guest_users: [],
            filter_by_email: null,
            filter_by_uuid: null,
            filter_by_role_id: null,
            user_fields: [
                { key: 'email', class: 'text-center align-middle', sortable: true },
                { key: 'uuid', label: 'UUID', class: 'text-center align-middle' },
                { key: 'created_at', label: 'Created at', class: 'text-center align-middle', sortable: true },
                { key: 'latest_entry_date', label: 'Latest entry date', class: 'text-center align-middle', sortable: true },
                { key: 'location', label: 'Location', class: 'text-center align-middle' },
                { key: 'is_active', label: 'Is active', class: 'text-center align-middle' },
            ],
            guest_fields: [
                { key: 'ip_address', label: 'IP address', class: 'text-center align-middle' },
                { key: 'user_agent', label: 'User agent', class: 'text-center align-middle' },
                { key: 'latest_entry_date', label: 'Latest entry date', class: 'text-center align-middle' },
                { key: 'location', label: 'Location', class: 'text-center align-middle' },
                { key: 'user', label: 'Guest user', class: 'text-center align-middle' },
                { key: 'space', label: 'Opened space', class: 'text-center align-middle' },
            ],
            options: [
                { value: null, text: "" },
                { value: 1, text: "Superadmin" },
                { value: 2, text: "Viewer of all spaces" },
                { value: 3, text: "Analyst" }
            ],
        }
    },
    components: {
        alert: Alert,
    },
    methods: {
        init() {
            this.download_list_of_users()
            this.download_list_of_guests()
        },
        download_list_of_users() {
            this.filter_by_uuid = this.filter_by_uuid == "" ? null : this.filter_by_uuid
            this.$http.post(this.$apiURL + '/admin/users', { email: this.filter_by_email, uuid: this.filter_by_uuid, role_id: this.filter_by_role_id },
                {
                    headers: this.$store.getters.authHeader
                })
                .then((res) => {
                    this.users = res.data
                    this.totalRows = this.users.length
                })
                .catch((error) => {
                    this.message = {
                        'message': error,
                        'type': "danger"
                    }
                });
        },
        download_list_of_guests() {
            this.$http.get(this.$apiURL + '/admin/guest_locations?page_num=' + this.guestCurrentPage,
                {
                    headers: this.$store.getters.authHeader
                })
                .then((res) => {
                    this.guest_users = res.data.items
                    this.guestTotalRows = res.data.total_records
                    this.$refs.guestTable.refresh();
                })
                .catch((error) => {
                    this.message = {
                        'message': error,
                        'type': "danger"
                    }
                });
        },
        truncate: function (data, num) {
            const reqdString = data.length > num ? data.split("").slice(0, num).join("") + "..." : data;
            return reqdString;
        }
    },
    created() {
        this.init();
    },
}
</script>
